import React, { Component } from "react";
import {
  showOnlyActiveTables,
  getFilter,
  getTable,
  getSearchTerm,
} from "../actions";
import { List, AutoSizer } from "react-virtualized";
import ReactTooltip from "react-tooltip";
const { connect } = require("react-redux");

class TableContainer extends Component {
  componentWillReceiveProps() {
    this.list.recomputeRowHeights();
  }

  renderRow = ({ key, index, parent, isScrolling, style }) => {
    return (
      <li className="list-group-item" style={style} key={key}>
        <span
          onClick={() => this.props.getTable(this.lista[index].id)}
          className={
            this.lista[index].active
              ? "antall activeElem itemhand"
              : "antall noactiveElem itemhand"
          }
        >
          {" "}
          {this.lista[index].value}
        </span>
        <span className="pull-right">
          <input
            className="inputsmall"
            id={`t__` + index}
            onChange={(e) =>
              this.props.getFilter(
                "tables",
                "t__" + this.lista[index].id,
                e,
                this.lista[index].id,
                this.props.choosenElements
              )
            }
            checked={this.lista[index].checked}
            type="checkbox"
          />
        </span>
      </li>
    );
  };

  render() {
    const {
      searchTerm,
      getSearchTerm,
      showOnlyActiveTables,
      showOnlyActTables,
    } = this.props;

    this.lista = this.props.data
      .filter((table, index) => {
        return showOnlyActTables
          ? table.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !==
              -1 && table.active
          : table.value
              .trim()
              .toLowerCase()
              .indexOf(searchTerm.toLowerCase()) !== -1;
      })
      .map((table, index) => {
        return table;
      });

    return (
      <div>
        <ReactTooltip />
        <div className="wellstyle">
          Document (<small>{this.lista.length}</small>)
          <span className="pull-right">
            <input
              id="showhideid"
              data-tip="Show / hide empty"
              type="checkbox"
              checked={showOnlyActTables}
              onChange={(e) => showOnlyActiveTables()}
            />
          </span>
        </div>

        <div className="form-group">
          <input
            className="form-control input-sm"
            type="text"
            id="searchcontainerid"
            placeholder="Search"
            onChange={(e) => getSearchTerm(e)}
          />
        </div>

        <ul className="navstyle list-group table-navstyle">
          <AutoSizer>
            {({ height, width }) => (
              <List
                ref={(list) => {
                  this.list = list;
                }}
                width={width}
                height={height}
                overscanRowCount={10}
                rowCount={this.lista.length}
                rowHeight={40}
                rowRenderer={this.renderRow}
                headerHeight={20}
              />
            )}
          </AutoSizer>
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showOnlyActTables: state.showOnlyActTables,
    searchTerm: state.searchTerm,
    choosenElements: state.choosenElements,
  };
}

const mapDispatchToProps = {
  getSearchTerm,
  getFilter,
  getTable,
  showOnlyActiveTables,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableContainer);



// WEBPACK FOOTER //
// ./src/components/TableContainer.js